import moment             from 'moment'
import React              from 'react'
import { DateTimePicker } from 'react-widgets'

export default class CustomPicker extends React.Component
  constructor: (props) ->
    super(props)

    @state = { open: @props.open ? false }

  render: ->
    value = @props.value.toDate() if moment.isMoment(@props.value)
    props = { format: 'd.M.y', ...@props, value, \
              onChange: (value) => @props.onChange(value and moment(value)) }

    if @props.openOnFocus
      props = { open: @state.open, onFocus: @onFocus.bind(@), \
                onClick: @onClick.bind(@), onToggle: @onToggle.bind(@), ...props }

    <DateTimePicker {...props} />

  onFocus: (event) ->
    @open(true) if event.target.tagName == 'INPUT'

  onClick: (event) ->
    @open(true) if event.target.tagName == 'INPUT'

  onToggle: (view) ->
    @open(not @state.open, view)

  open: (shouldOpen, view) ->
    unless view
      view = if @props.time and not @props.date then 'time' else 'date'

    @setState(open: if shouldOpen then view else false)
